import * as v from 'valibot';

export type TCategory = TCategoryIo & {
  parentId: number | null;
};

export type TCategoryIo = {
  id: number;
  name: string;
  children: TCategoryIo[];
};

export const CategorySchema: v.BaseSchema<TCategoryIo> = v.object({
  id: v.number(),
  name: v.string(),
  children: v.array(v.lazy(() => CategorySchema)),
});
